
















import { defineComponent, PropType } from '@vue/composition-api';
import useGlobalTranslations         from '@/hooks/use-global-translations';
import { TranslateResult }           from 'vue-i18n';
import { Computed }                  from '@/types';
import { DrawerAttrs }               from '@/views/price-optimizer/price-optimizer.types';
import cDrawer                       from '../drawer/drawer.component.vue';

export default defineComponent({
  name: 'cDrawerContent',
  components: {
    cDrawer,
  },
  props: {
    panelAttrs: {
      type: Object as PropType<Computed<DrawerAttrs>>,
      default: () => ({}),
    },
    contentVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const noDataDefined: TranslateResult = useGlobalTranslations('errors.noDataDefined', [ 'columns' ]);
    const onDrawerClose = (): void => {
      context.emit('onDrawerClose');
    };

    return {
      noDataDefined,
      onDrawerClose,
    };
  },
});
